export default __webpack_public_path__ + "static/media/cstmtu.d0e8b928.svg";